import { createContext } from 'react';

export const FORM_LOGIN_NAME = 'FORM_LOGIN_NAME';
export const FORM_NEW_PASSWORD_NAME = 'FORM_NEW_PASSWORD_NAME';
export const FORM_FORGOT_PASSWORD_NAME = 'FORM_FORGOT_PASSWORD_NAME';
export const FORM_REGISTER_PASSWORD_NAME = 'FORM_REGISTER_PASSWORD_NAME';
export const FORM_ENTER_AUTHENTICATION_CODE = 'FORM_ENTER_AUTHENTICATION_CODE';

export const USER_LOGIN_URL = '/user/loginJson';
export const USER_ADFS_LOGIN_URL = '/user/AdfsLoginJson';
export const USER_AZURE_AD_LOGIN_URL = '/user/AzureAdLoginJson';
export const USER_FORGOT_PASSWORD_URL = '/user/forgotPasswordJson';
export const USER_NEW_PASSWORD_URL = '/user/newPasswordjson';
export const USER_SET_PASSWORD_URL = '/user/setPasswordjson';
export const USER_SMS_PINCODE_VERIFICATION_URL = '/user/smsPinCodeVerificationJson';
export const USER_PERSONAL_DATA_VERIFICATION = '/user/personalDataVerificationJson';
export const USER_TWO_FACTOR_AUTH = '/user/TwoFactorAuth';
export const USER_RESET_TWO_FACTOR_AUTH = '/user/resetTwoFactorAuth';

export const actionTypeEnum = {
	LOGIN: 'LogIn',
	LOGIN_FORM: 'LogInForm',
	LOGIN_FORM_GET: 'FetchLoginForm',
	FORGOT_PASSWORD_FORM: 'FORGOT_PASSWORD_FORM',
	NEW_PASSWORD: 'NewPassword',
	SET_PASSWORD: 'SetPassword',
	ACCEPT_TERMS_AND_CONDITIONS: 'AcceptTermsAndConditions',
	MULTIPLE_ORGANIZATION_CONFLICT: 'MultipleOrganizationConflict',
	WRONG_DEEPLINK: 'WrongDeeplink',
	WRONG_LOGIN_USE_ADFS: 'WrongLoginUseAdfs',
	WRONG_LOGIN_USE_AZURE_AD: 'WrongLogInUseAzureAd',
	CHECK_SMS_PIN_CODE_REGISTER_PASSWORD: 'CheckSmsPinCodeRegisterPassword',
	CHECK_SMS_PIN_CODE_2FA: 'CheckSmsPinCode2FA',
	CHECK_SMS_PIN_CODE_2FA_SETUP: 'CheckSmsPinCode2FASetup',
	CHECK_AUTH_CODE: 'CheckAuthCode',
	SET_UP_AUTH_APP: 'SetUpAuthApp',
	SESSION_EXPIRED: 'SessionExpired',
	CAN_NOT_SEND_SMS: 'CannotSendSms',
	SORRY_AN_ERROR_OCCURRED: 'SorryAnErrorOccurred',
	WRONG_PIN_CODE: 'WrongPinCode',
	PIN_CODE_ATTEMPTS_EXCEEDED: 'CheckSmsPinCodeAttemptsExceeded',
	DOCUMENT_PERSONALIZATION: 'CheckPersonalData',
	TWO_FACTOR_AUTH_REQUIRED: 'TwoFactorAuthRequired',
	TWO_FACTOR_AUTH_VERIFIED: 'TwoFactorAuthVerified',
	PERSONAL_DATA_NOT_FOUND: 'PersonalDataNotFound',
	PASSWORD_NOT_UNIQUE: 'PasswordNotUnique',
	CHECK_CODE_ATTEMPTS_EXCEEDED: 'CheckCodeAttemptsExceeded',
};

export const PROVIDER_ENUM = {
	AZURE_AD: 'azuread',
	ADFS: 'adfs',
};

export const AuthenticationContext = createContext({});
